// ============================================================
//  CONFIGURACIÓN PRINCIPAL — edita este archivo para cambiar
//  el contenido del landing sin tocar los componentes.
// ============================================================

/** URL de tu sistema web (reemplaza con la URL real) */
export const SYSTEM_URL = 'https://glorysboutique.ewoldygroup.com/';

/** Nombre del negocio */
export const BUSINESS_NAME = "Glory's Boutique";

/** Tagline corto */
export const TAGLINE = 'Moda para toda la familia';

// ============================================================
//  SLIDES DEL HERO SLIDER
//  Puedes agregar, quitar o editar diapositivas aquí.
// ============================================================
//
//  Cada slide acepta una propiedad "artworks" — array de
//  elementos visuales que flotan sobre el fondo estilo
//  pantalla de carga del GTA 5.
//
//  Propiedades de cada artwork:
//    type       → 'svg-figure' | 'image'
//    figure     → (solo svg-figure) 'hanger' | 'dress' | 'bag' |
//                 'tag' | 'mannequin' | 'diamond' | 'star'
//    src        → (solo image) ruta a tu imagen, e.g. '/images/modelo.png'
//    position   → { x: '65%', y: '15%' }  posición en el slide
//    size       → número en px (ancho y alto del contenedor)
//    color      → color de trazo SVG, e.g. 'rgba(255,255,255,0.25)'
//    opacity    → opacidad final cuando el slide está activo (0–1)
//    speed      → 'slow' | 'medium' | 'fast'  (velocidad del drift)
//    direction  → 'float' | 'up' | 'down' | 'left' | 'right' |
//                 'diagonal-ur' | 'diagonal-dl'
//    delay      → segundos de retraso de animación (para desfasar piezas)
//    zIndex     → capas (3 = sobre el bg, debajo del texto)
//    blur       → desenfoque en px (útil para capas de fondo)
// ============================================================

export const SLIDES = [
  {
    id: 0,
    eyebrow: 'Bienvenidos a',
    title: "Glory's Boutique",
    subtitle:
      'Moda para toda la familia en el corazón de León, Nicaragua. Fundada en 2016 con amor y dedicación.',
    cta: 'Ir al sistema',
    wrods:'#be143f',
    accent: '#f5f3f3',
    bg: '#5a28153b',
    shapes: [
      { type: 'circle', cx: '78%', cy: '18%', r: 240, color: '#D85A30', opacity: 0.12, delay: 0 },
      { type: 'circle', cx: '8%',  cy: '80%', r: 150, color: '#993C1D', opacity: 0.09, delay: 1 },
      { type: 'rect',   cx: '58%', cy: '55%', size: 320, rot: 38,  color: '#711800', opacity: 0.08, delay: 2 },
    ],
    // ── Artworks flotantes estilo GTA ──────────────────────
    artworks: [
      {
        type: 'svg-figure',
        figure: 'mannequin',
        position: { x: '72%', y: '5%' },
        size: 280,
        color: 'rgba(255,200,160,0.22)',
        opacity: 0.9,
        speed: 'slow',
        direction: 'float',
        delay: 0,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'hanger',
        position: { x: '12%', y: '8%' },
        size: 130,
        color: 'rgba(255,180,140,0.30)',
        opacity: 0.9,
        speed: 'medium',
        direction: 'diagonal-ur',
        delay: 1.2,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'tag',
        position: { x: '82%', y: '62%' },
        size: 90,
        color: 'rgba(255,200,160,0.25)',
        opacity: 0.9,
        speed: 'slow',
        direction: 'up',
        delay: 2.5,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'diamond',
        position: { x: '5%', y: '55%' },
        size: 70,
        color: 'rgba(255,220,180,0.18)',
        opacity: 0.9,
        speed: 'fast',
        direction: 'float',
        delay: 0.8,
        zIndex: 3,
        blur: 1,
      },
    ],
    tag: 'Desde 2016',
  },

  {
    id: 1,
    eyebrow: 'Nuestra misión',
    title: 'Ropa de calidad, precios accesibles',
    subtitle:
      'Atención personalizada y servicio eficiente que satisface las necesidades de cada cliente de la comunidad.',
    cta: 'Explorar sistema',
    accent: 'rgb(241, 247, 245)',
    bg: '#021a10',
    shapes: [
      { type: 'circle', cx: '12%', cy: '12%', r: 190, color: '#1D9E75', opacity: 0.12, delay: 0.5 },
      { type: 'circle', cx: '85%', cy: '75%', r: 210, color: '#0F6E56', opacity: 0.09, delay: 0 },
      { type: 'rect',   cx: '3%',  cy: '50%', size: 260, rot: -22, color: '#085041', opacity: 0.08, delay: 2 },
    ],
    artworks: [
      {
        type: 'svg-figure',
        figure: 'dress',
        position: { x: '68%', y: '2%' },
        size: 260,
        color: 'rgba(160,255,210,0.22)',
        opacity: 0.9,
        speed: 'slow',
        direction: 'float',
        delay: 0,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'bag',
        position: { x: '8%', y: '15%' },
        size: 120,
        color: 'rgba(130,240,190,0.28)',
        opacity: 0.9,
        speed: 'medium',
        direction: 'diagonal-dl',
        delay: 1.5,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'star',
        position: { x: '80%', y: '60%' },
        size: 80,
        color: 'rgba(160,255,210,0.20)',
        opacity: 0.9,
        speed: 'fast',
        direction: 'float',
        delay: 0.5,
        zIndex: 3,
        blur: 1,
      },
      {
        type: 'svg-figure',
        figure: 'hanger',
        position: { x: '15%', y: '65%' },
        size: 100,
        color: 'rgba(100,220,170,0.18)',
        opacity: 0.9,
        speed: 'slow',
        direction: 'right',
        delay: 3,
        zIndex: 3,
      },
    ],
    tag: 'Nuestra misión',
  },

  {
    id: 2,
    eyebrow: 'Catálogo',
    title: 'Casual, Formal & Deportivo',
    subtitle:
      'Variedades para hombres, mujeres y niños — más accesorios y juguetes para toda la familia.',
    cta: 'Ver en sistema',
    accent: 'rgb(251, 251, 255)',
    bg: '#2d23813b',
    shapes: [
      { type: 'circle', cx: '88%', cy: '8%',  r: 220, color: '#7F77DD', opacity: 0.13, delay: 0 },
      { type: 'circle', cx: '16%', cy: '85%', r: 180, color: '#534AB7', opacity: 0.10, delay: 1.5 },
      { type: 'rect',   cx: '38%', cy: '28%', size: 300, rot: 55, color: '#3C3489', opacity: 0.07, delay: 3 },
    ],
    artworks: [
      {
        type: 'svg-figure',
        figure: 'mannequin',
        position: { x: '70%', y: '3%' },
        size: 300,
        color: 'rgba(200,190,255,0.20)',
        opacity: 0.9,
        speed: 'slow',
        direction: 'float',
        delay: 0,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'diamond',
        position: { x: '6%', y: '10%' },
        size: 100,
        color: 'rgba(180,170,255,0.28)',
        opacity: 0.9,
        speed: 'medium',
        direction: 'up',
        delay: 0.8,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'bag',
        position: { x: '78%', y: '62%' },
        size: 110,
        color: 'rgba(200,190,255,0.22)',
        opacity: 0.9,
        speed: 'slow',
        direction: 'diagonal-ur',
        delay: 2,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'star',
        position: { x: '10%', y: '60%' },
        size: 75,
        color: 'rgba(160,150,240,0.18)',
        opacity: 0.9,
        speed: 'fast',
        direction: 'float',
        delay: 1.5,
        zIndex: 3,
        blur: 1,
      },
    ],
    tag: 'Catálogo',
  },

  {
    id: 3,
    eyebrow: 'Nuestra visión',
    title: 'Tecnología al servicio de la moda',
    subtitle:
      'Sistema digital para gestionar inventario, ventas y clientes — más eficiencia, menos errores.',
    cta: 'Acceder ahora',
    accent: '#f5ecef',
    bg: '#8f155a3f',
    shapes: [
      { type: 'circle', cx: '50%', cy: '2%',  r: 200, color: '#D4537E', opacity: 0.12, delay: 0.8 },
      { type: 'circle', cx: '78%', cy: '68%', r: 170, color: '#993556', opacity: 0.09, delay: 0 },
      { type: 'rect',   cx: '2%',  cy: '18%', size: 280, rot: 15, color: '#72243E', opacity: 0.08, delay: 4 },
    ],
    artworks: [
      {
        type: 'svg-figure',
        figure: 'dress',
        position: { x: '66%', y: '0%' },
        size: 270,
        color: 'rgba(255,160,195,0.22)',
        opacity: 0.9,
        speed: 'slow',
        direction: 'float',
        delay: 0,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'tag',
        position: { x: '8%', y: '12%' },
        size: 110,
        color: 'rgba(255,140,180,0.28)',
        opacity: 0.9,
        speed: 'medium',
        direction: 'diagonal-ur',
        delay: 1,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'hanger',
        position: { x: '80%', y: '58%' },
        size: 100,
        color: 'rgba(255,160,195,0.22)',
        opacity: 0.9,
        speed: 'slow',
        direction: 'down',
        delay: 2.2,
        zIndex: 3,
      },
      {
        type: 'svg-figure',
        figure: 'star',
        position: { x: '5%', y: '62%' },
        size: 72,
        color: 'rgba(240,130,170,0.18)',
        opacity: 0.9,
        speed: 'fast',
        direction: 'float',
        delay: 0.4,
        zIndex: 3,
        blur: 1,
      },
    ],
    tag: 'Visión',
  },
];

// ============================================================
//  LINKS DE REDES SOCIALES / PLATAFORMAS
// ============================================================
export const LINKS = [
  {
    id: 'facebook',
    label: 'Facebook',
    desc: 'Síguenos y conoce nuestras ofertas',
    url: 'https://facebook.com/glorysboutiqueni',
    iconBg: '#e8f0fe',
    iconColor: '#1877F2',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    desc: 'Inspiración de moda día a día',
    url: 'https://www.instagram.com/glorysboutiqueni',
    iconBg: '#fce4ec',
    iconColor: '#E1306C',
  },
  {
    id: 'sistema',
    label: 'Sistema Web',
    desc: 'Gestión de inventario y ventas',
    url: SYSTEM_URL,
    iconBg: '#fbe9e7',
    iconColor: '#D85A30',
    featured: true,
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    desc: 'Contáctanos directo',
    url: 'https://wa.me/50585547552',
    iconBg: '#e8f5e9',
    iconColor: '#25D366',
  },
  {
    id: 'ubicacion',
    label: 'Ubicación',
    desc: 'Santa Rosa del Peñón, León',
    url: 'https://maps.google.com/?q=Mina+La+India+Leon+Nicaragua',
    iconBg: '#e3f2fd',
    iconColor: '#4285F4',
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    desc: 'Tendencias y novedades',
    url: 'https://tiktok.com/@glorysboutique  ',
    iconBg: '#f5f5f5',
    iconColor: '#010101',
  },
];

// ============================================================
//  ESTADÍSTICAS
// ============================================================
export const STATS = [
  { value: '2016',  label: 'Año de fundación' },
  { value: '5+',    label: 'Módulos del sistema' },
  { value: 'León',  label: 'Nicaragua' },
  { value: '100%',  label: 'Atención personalizada' },
];

/** Intervalo en ms entre slides automáticos */
export const SLIDE_INTERVAL = 5000;
